import React, { useEffect } from 'react';
import { useAuthStore } from '../store/authStore';
import { redirectToCustomerLogin } from '../lib/sso';

const ProtectedRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { isAuthenticated, isLoading, checkAuth } = useAuthStore();

  useEffect(() => {
    checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isLoading && !isAuthenticated) redirectToCustomerLogin();
  }, [isLoading, isAuthenticated]);

  if (isLoading || !isAuthenticated) {
    // While checking auth - or while the browser navigates to the customer
    // login - show the spinner so nothing flashes.
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary-500 border-t-transparent" />
      </div>
    );
  }
  return children;
};

export default ProtectedRoute;
